import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
};

const filterDrawerSlice = createSlice({
  name: "filterDrawer",
  initialState,
  reducers: {
    openDrawer: (state) => {
      state.open = true;
    },
    closeDrawer: (state) => {
      state.open = false;
    },
    toggleDrawer: (state) => {
      state.open = !state.open;
    },
  },
});

export const {
  openDrawer,
  closeDrawer,
  toggleDrawer,
} = filterDrawerSlice.actions;

export default filterDrawerSlice.reducer;